<script lang="ts">
    import { reviewsIconCollectionManagerContextToken } from "@apps/reviews/context_tokens";
    import Icon from "@components_v2/Icon.svelte";
    import ProgressBar from "@components_v2/Progress/ProgressBar.svelte";
    import Text from "@components_v2/Typography/Text.svelte";
    import { getTypedContext } from "@lib/svelte-typed-context";

    export let reviewsCount: number;
    export let reviewCount: number;
    export let rate: number;

    const iconCollection$ = getTypedContext(
        reviewsIconCollectionManagerContextToken
    ).getIconCollection();

    $: percentage = (reviewCount / reviewsCount) * 100;
</script>

<li class="gw-rv-total-rate-bar">
    <div class="gw-rv-total-rate-bar__rating">
        <Text
            variant="body-sm"
            fontWeight="semibold"
            tone="inherit"
            class="gw-rv-total-rate-bar__text"
        >
            {rate}
        </Text>
        <Icon
            width={12}
            height={12}
            viewBox="0 0 20 20"
            title="star rating icon"
        >
            <svelte:component this={$iconCollection$?.filled} />
        </Icon>
    </div>
    <ProgressBar
        progress={percentage}
        animation={false}
        barColor="--gw-rv-icon-starColor"
    />
    <div class="gw-rv-total-rate-bar__count">
        <Text variant="body-sm" fontWeight="semibold" tone="inherit">
            {`${reviewCount}`}
        </Text>
    </div>
</li>

<style lang="postcss">
    .gw-rv-total-rate-bar {
        display: flex;
        align-items: center;
        gap: var(--gw-space-100);

        :global(.gw-rv-total-rate-bar__text) {
            width: var(--gw-width-200);
            text-align: center;
        }

        &__rating {
            min-width: var(--gw-width-600);
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: var(--gw-space-050);
        }

        &__count {
            min-width: var(--gw-width-500);
        }
    }
</style>
